<template>
  <div>
    <div class="row no-gutters">
      <div class="col-12 col-md-11 mx-auto d-flex justify-content-md-around">
        <div class>
          <div class="d-flex flex-column align-items-around" style="height:150px">
            <div class="d-flex">
              <select class="custom-select">
                <option selected>分類一</option>
              </select>
              <select class="custom-select">
                <option selected>分類一</option>
              </select>
            </div>
            <div class="d-flex">
              <div class="form-check">
                <label class="form-check-label">
                  <input type="checkbox" class="form-check-input" />
                  上架商品
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="checkbox" class="form-check-input" />
                  下架商品
                </label>
              </div>
            </div>
            <div class="d-flex align-items-center flex-fill" style="width:550px">
              <div class="d-flex">
                <select class="custom-select">
                  <option selected>商品代碼</option>
                </select>
              </div>
              <div>
                <b-form-input size="sm"></b-form-input>
              </div>
              <div class="ml-3 d-flex flex-column align-items-start">
                <b-form-radio name="proEditRadio" value="A">所有分類</b-form-radio>
                <b-form-radio name="proEditRadio" value="B">僅於此分類內</b-form-radio>
              </div>
              <button type="button" class="ml-3 btn btn-primary">查詢</button>
            </div>
          </div>
        </div>
        <div style="width:400px">
          <div class="d-flex justify-content-between justify-content-md-around flex-md-wrap">
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center">
                <font-awesome-icon :icon="['fas', 'copy']" :style="{ color: 'gray' }" />
                <a href="#">複製商品</a>
              </div>
              <div class="d-flex align-items-center">
                <font-awesome-icon :icon="['fas', 'file-export']" :style="{ color: 'blue' }" />
                <a href="#">匯入匯出他站商品</a>
              </div>
              <div class="d-flex align-items-center">
                <font-awesome-icon :icon="['fas', 'file-excel']" :style="{ color: 'green' }" />
                <a href="#">匯入商品Excel</a>
              </div>
              <div class="d-flex align-items-center">
                <font-awesome-icon :icon="['fas', 'file-excel']" :style="{ color: 'green' }" />
                <a href="#">匯出商品Excel</a>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div class="d-flex align-items-center">
                <font-awesome-icon :icon="['fas', 'plus-square']" :style="{ color: 'red' }" />
                <a href="#">安全庫存量通知：(未)</a>
              </div>
              <div class="d-flex align-items-center">
                <font-awesome-icon :icon="['fas', 'database']" :style="{ color: 'gray' }" />
                <a href="#">庫存量排行</a>
              </div>
              <div class="d-flex align-items-center">
                <font-awesome-icon :icon="['fas', 'clock']" :style="{ color: 'gray' }" />
                <a href="#">排程下架</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-12 d-flex">
        <ul class="nav nav-tabs flex-fill">
          <li class="nav-item">
            <router-link class="nav-link"
              :class="{active:path === '/productManage/proEdit/proBaseField'}"
              :to="{name:'proBaseField'}">基本欄位
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link"
              :class="{active:path === '/productManage/proEdit/proCost'}"
              :to="{name:'proCost'}">消費相關
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link"
              :class="{active:path === '/productManage/proEdit/proSpecification'}"
              :to="{name:'proSpecification'}">商品規格
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link"
              :class="{active:path === '/productManage/proEdit/proStock'}"
              :to="{name:'proStock'}">庫存
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link"
              :class="{active:path === '/productManage/proEdit/proOther'}"
              :to="{name:'proOther'}">其他
            </router-link>
          </li>
        </ul>
      </div>
      <router-view></router-view>
    </div>

    <!-- <div class="row no-gutters">
      <div class="col-12 col-md-8 order-2 order-md-1 mx-auto d-flex">
        <div class="d-flex flex-column align-items-start">
          <div class="d-flex">
            <select class="custom-select">
              <option selected>分類一</option>
            </select>
            <select class="custom-select">
              <option selected>分類一</option>
            </select>
          </div>
          <div class="d-flex">
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" />
                上架商品
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" />
                下架商品
              </label>
            </div>
          </div>
          <div class="d-flex align-items-center flex-fill" style="width:550px">
            <div class="d-flex">
              <select class="custom-select">
                <option selected>商品代碼</option>
              </select>
            </div>
            <div>
              <b-form-input size="sm"> </b-form-input>
            </div>
            <div class="d-flex flex-column align-items-start">
              <b-form-radio name="proEditRadio" value="A">所有分類</b-form-radio>
              <b-form-radio name="proEditRadio" value="B">僅於此分類內</b-form-radio>
            </div>
            <button type="button" class="btn btn-primary">查詢</button>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4 order-1 order-md-2 row no-gutters d-flex justify-content-end">
        <div class="col-6 d-flex justify-content-between" style="width:500px">
        <div class="col-6 d-flex flex-column align-items-start">
          <div class="d-flex align-items-center ">
            <font-awesome-icon :icon="['fas', 'copy']" :style="{ color: 'gray' }" />
            <a href="#">複製商品</a>
          </div>
          <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['fas', 'file-export']" :style="{ color: 'blue' }" />
            <a href="#">匯入匯出他站商品</a>
          </div>
          <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['fas', 'file-excel']" :style="{ color: 'green' }" />
            <a href="#">匯入商品Excel</a>
          </div>
          <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['fas', 'file-excel']" :style="{ color: 'green' }" />
            <a href="#">匯出商品Excel</a>
          </div>
        </div>
        <div class="col-6 d-flex flex-column align-items-start">
          <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['fas', 'plus-square']" :style="{ color: 'red' }" />
            <a href="#">安全庫存量通知：(未)</a>
          </div>
          <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['fas', 'database']" :style="{ color: 'gray' }" />
            <a href="#">庫存量排行</a>
          </div>
          <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['fas', 'clock']" :style="{ color: 'gray' }" />
            <a href="#">排程下架</a>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="d-flex flex-fill justify-content-center overflow-auto">
      <b-card class="w-100" no-body>
        <b-card-header header-tag="nav">
          <b-nav id="InsertHeader" card-header tabs align="left">
            <b-nav-item to="/productManage/proEdit/proBaseField" class="mynavbtn">基本欄位</b-nav-item>
            <b-nav-item to="/productManage/proEdit/proCost" class="mynavbtn">消費相關</b-nav-item>
            <b-nav-item to="/productManage/proEdit/proSpecification" class="mynavbtn">商品規格
            </b-nav-item>
            <b-nav-item to="/productManage/proEdit/proStock" class="mynavbtn">庫存</b-nav-item>
            <b-nav-item to="/productManage/proEdit/proOther" class="mynavbtn">其他</b-nav-item>
          </b-nav>
        </b-card-header>
        <b-card-body class="text-center">
          <router-view></router-view>
        </b-card-body>
      </b-card>
    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  computed: {
    path() {
      return this.$route.path;
    },
  },
};

</script>

<style lang="scss">
  .d-flex.justify-content-between {
    a {
      margin-left: 5px;
    }
  }

</style>
